module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABIAAAAWCAMAAAD6gTxzAAAARVBMVEUAAACmAQCdAACmAQCmAQCmAACmAACmAACmAACmAACmAACmAACmAACmAACnAAClAAClAACiAAClAACmAACmAAClAACmAQAl4EYuAAAAFnRSTlMA7w3n39bLv7GVh3dqXE1ANCkfF6OicJUdJwAAAFVJREFUGNOF0UkOgEAIRNFuHNtZW//9j+rKkFgLWL4EAkUar/Qv8iwE3S4ETxUiL0LQH0JQTIhmFYLhFCJP9pFXu8XkjT4+XKKYHBSefVeJMAxa3/ECyaQQojsX/OMAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/pagess/gdd112/h1-3.png
// module id = VRtE
// module chunks = 1